module.exports = __webpack_public_path__ + "static/media/banner.88553136.jpeg";